export const formatDecimal = (value: number, precision = 2) => value.toFixed(precision)

export const toPrecision = (value: number, precision = 2) =>
  Math.round(value * Math.pow(10, precision)) * Math.pow(10, -precision)
